import React from 'react';
import {FaCalendar} from "react-icons/fa";
import {FaLocationDot} from "react-icons/fa6";
import projectUtils from "../../../../../../utils/project-utils.js";
import BaseNode from "./base-node.jsx";
import {Types} from "../enums.js";
import {getAssetPath} from "../../../../../../utils/get-asset-path.js";
import CheckHasData from "../check-has-data.jsx";

const Passage = ({data, selected}) => {
    const image = () => {
        const {imagePath} = data

        return (
            <>
                <div className={"border-top !border-[#cfcfcf] bg-[#f3f3f4]"}>
                    <div className="h-[72px]">
                        <img
                            src={imagePath}
                            alt={`passage-image`}
                            className="m-auto h-full w-full object-contain"
                            onError={(e) => {
                                e.target.src = getAssetPath("img/sentry.imgnotfound.large.748x480.png");
                            }}
                        />
                    </div>
                </div>
            </>
        )
    }

    const icon = (
        <img
            className="m-auto w-[18px]"
            src={getAssetPath("img/dashboard-svg/sw.vehicle.svg")}
            alt="image"
        />
    );

    const title = (
        <>
            <p className={"!mb-[2px] text-[#fff]"}><b>Passagem</b></p>
            <p className={"mb-0 text-[6px] text-[#fff]"}>{data.plate}</p>
        </>
    )

    const infoBlock = () => {
        const {capturePlaceDescription, procCaptureTime} = data;

        return (
            <div className="p-1 text-[7px] border-top border-bottom !border-[#cfcfcf]">
                <div className={"flex items-center"}>
                    <FaCalendar/>
                    <p className={"ml-1 mb-0"}>Data/Hora: <CheckHasData value={projectUtils.formatDate(procCaptureTime)} /></p>
                </div>

                <div className={"flex items-center"}>
                    <FaLocationDot />
                    <p className={"ml-1 mb-0"}>Local: {capturePlaceDescription}</p>
                </div>
            </div>
        )
    }

    return (
        <BaseNode
            icon={icon}
            title={title}
            image={image()}
            onSearchConnections={true}
            infoBlock={infoBlock()}
            showAddConnectionButton={true}
            selected={selected}
            bgHeader={"bg-[#A7B1C2]"}
            bgBody={"bg-[#ffffff]"}
            type={Types.PASSAGE}
        />
    );
};

export default Passage;